module.exports = __webpack_public_path__ + "img/404.531ee489.jpg";